import { createCanBoundTo } from '@casl/react';
import { abilities } from 'config/ability';

export default createCanBoundTo(abilities);
